export default {
	"refund.CopiedSuccessfully": "已成功复制!",
	"refund.ReplicationIsNotSupported": "不支持复制",
	"refund.RefundSuccessfully": "退款成功",
	"refund.ParameterError": "参数错误!",
	"refund.callOfficial": "叫叫官方",
	"refund.RefundInformation": "退款信息",
	"refund.refundOrderNumber": "退款单号",
	"refund.copy": "复制",
	"refund.RefundType": "退款类型",
	"refund.reasonForReturn": "退款原因",
	"refund.TotalAmountRefunded": "实退总金额",
	"refund.RefundInstructions": "退款说明"
}